module.exports = __webpack_public_path__ + "static/szkjcyy-c3187052e25199f0c239bdd9b7796d28.jpg";